<script>
  import { signOut } from 'firebase/auth';
  import { onMount } from 'svelte';
  import { firebaseAuth as auth, user, ux, components, account, defaultUx, defaultComponents } from '../../store';
  import { pages } from '../../config';

  onMount(async () => {
    await signOut($auth);
    $user = null;
    $components = defaultComponents;
    $account = null;
    $ux = defaultUx;
    window.location = pages.entry.url;
  });
</script>

...
